import Vue from 'vue';
// import { Message, MessageBox } from 'element-ui';
import _ from 'lodash';
import {
    GET_ADD_AGENCY_GOODS_CATES_REQUEST,
    GET_ADD_AGENCY_GOODS_CATES_SUCCESS,
    GET_ADD_AGENCY_GOODS_CATES_FAILURE,
    CLEAR_ADD_AGENCY_GOODS_CATES,
    GET_ADD_AGENCY_LIST_REQUEST,
    GET_ADD_AGENCY_LIST_SUCCESS,
    GET_ADD_AGENCY_LIST_FAILURE,
    UPDATE_ADD_AGENCY_LIST,
    UPDATE_ADD_AGENCY_LIST_PARAMS,
    RESET_ADD_AGENCY_LIST,
    RESOLVE_ADD_AGENCY_LIST_PARAMS,
} from '../mutationTypes';

const state = {
    loading: false,
    cate1_id: '',
    cate2_id: '',
    cate3_id: '',
    cateL1: [],
    cateL2: [],
    cateL3: [],
    cateLoading:false,
    isSameCity: 0, // 是否同城（0：全部，1：同城）
    isActivity: 0, // 是否活动（0：全部，1：活动）
    isFreePostage: 0, // 是否包邮（0：全部，1：包邮）
    page: 1,
    pagesize: 20,
    goodsName: '',
    goodsBrand: '',
    listData: [],
    pageCount: 1,
    reqParams: {},
};

const mutations = {
    [GET_ADD_AGENCY_GOODS_CATES_REQUEST](state) {
        state.cateLoading = true;
    },
    [GET_ADD_AGENCY_GOODS_CATES_SUCCESS](state, res) {
        state.cateLoading = false;
        const { level } = res;
        state[`cateL${level || 1 || 4}`] = res.list;
    },
    [GET_ADD_AGENCY_GOODS_CATES_FAILURE](state) {
        state.cateLoading = false;
    },
    [CLEAR_ADD_AGENCY_GOODS_CATES](state, level) {
        if (level === 2) {
            // 一级不用清空
            state.cateL2 = [];
            state.cate2_id = '';
            state.cateL3 = [];
            state.cate3_id = '';
        } else if (level === 3) {
            state.cateL3 = [];
            state.cate3_id = '';
        }
    },
    [GET_ADD_AGENCY_LIST_REQUEST](state) {
        state.loading = true;
    },
    [GET_ADD_AGENCY_LIST_SUCCESS](state, res) {
        state.loading = false;
        state.pageCount = res.page_count;
        state.listData = res.listData;
    },
    [UPDATE_ADD_AGENCY_LIST](state, res) {
        state.listData = res;
    },
    [GET_ADD_AGENCY_LIST_FAILURE](state) {
        state.loading = false;

        state.pageCount = 1;
        state.listData = [];
    },
    // 更新请求参数
    [UPDATE_ADD_AGENCY_LIST_PARAMS](state, params) {
        const { page } = params;
        // const {
        //     goodsName, goodsBrand, page,
        //     isSameCity, isActivity, isFreePostage,
        //     cate1_id, cate2_id, cate3_id
        // } = params;

        // if (goodsName || goodsName === '') state.goodsName = goodsName;
        // if (goodsBrand || goodsBrand === '') state.goodsBrand = goodsBrand;
        // if (cate1_id || cate1_id === '') state.cate1_id = cate1_id;
        // if (cate2_id || cate2_id === '') state.cate2_id = cate2_id;
        // if (cate3_id || cate3_id === '') state.cate3_id = cate3_id;
        // if (isSameCity) state.isSameCity = isSameCity;
        // if (isActivity) state.isActivity = isActivity;
        // if (isFreePostage) state.isFreePostage = isFreePostage;
        if (page) {
            state.page = page;
            state.reqParams.page = page; // 分页要进行请求
        }
        state[Object.keys(params)[0]] = params[Object.keys(params)[0]];
    },
    [RESET_ADD_AGENCY_LIST](state) {
        _.extend(state, _.cloneDeep({
            loading: false,
            cate1_id: '',
            cate2_id: '',
            cate3_id: '',
            cateL1: [],
            cateL2: [],
            cateL3: [],
            cateLoading: false, // 商品分类loading
            isSameCity: 0,
            isActivity: 0,
            isFreePostage: 0,
            page: 1,
            pagesize: 20,
            goodsName: '',
            goodsBrand:'',
            listData: [],
            pageCount: 1,
            reqParams: {}
        }));
    },
    [RESOLVE_ADD_AGENCY_LIST_PARAMS](state, reqParams) {
        state.reqParams = reqParams;
    },
};

export const actions = {
    async getAddAgencyList({ commit }) {
        commit(GET_ADD_AGENCY_LIST_REQUEST);
        const res = await Vue.$ajax.get('getStoreCouponGoodsList', state.reqParams);
        if (!res.errorType) {
            commit(GET_ADD_AGENCY_LIST_SUCCESS, res);
        } else {
            commit(GET_ADD_AGENCY_LIST_FAILURE);
        }
    },
    resolveAddAgencyListParams({ commit }) {
        let params = _.pick(state, ['goodsName', 'goodsBrand',
            'cate1_id', 'cate2_id', 'cate3_id',
            'isSameCity', 'isActivity', 'isFreePostage',
            'page', 'pagesize']);

        params = Object.assign({}, params);
        commit(RESOLVE_ADD_AGENCY_LIST_PARAMS, params);
    },
    resetAddAgencyList({ commit }) {
        commit(RESET_ADD_AGENCY_LIST);
    },
    async getAddAgencyGoodsCates({ commit }, query) {
        commit(GET_ADD_AGENCY_GOODS_CATES_REQUEST);
        const { level, cateId, isOrthers } = query;
        const list = await Vue.$ajax.get('getGoodsCate', {
            cateId,
            isOrthers,
            is_noagent: 1
        });
        const res = {
            list,
            level
        };
        if (!list.errorType) {
            commit(GET_ADD_AGENCY_GOODS_CATES_SUCCESS, res);
        } else {
            commit(GET_ADD_AGENCY_GOODS_CATES_FAILURE);
        }
    },
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/addAgencyGoods.js